import React from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import RefreshIcon from '@mui/icons-material/Refresh';
import { useNavigate } from 'react-router-dom';

function PageHeader({ title, onRefresh, refreshNeeded }) {
  const navigate = useNavigate();
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      mb={2}
      sx={{
        border: 'none',
      }}
    >
      <IconButton onClick={() => navigate('/')} size="large" sx={{ color:"#1e88e5" }}>
        <ArrowBackIosNewIcon />
      </IconButton>
      <Typography variant="h1" component="h1" color="primary" sx={{ flex: 1, textAlign: 'center', color:"#1e88e5" }} className={"pageHeader"}>
        {title}
      </Typography>
      {refreshNeeded
        ?
        <IconButton onClick={onRefresh} size="large" sx={{color:"#1e88e5"}}>
          <RefreshIcon />
        </IconButton>
        :
        <></>
      }

    </Box>
  );
}

export default PageHeader;